import create, { SetState, StateCreator, StoreApi } from "zustand";

interface EolStore {
  eolData: any;
  setEolData: (x: any) => void;
  dataCardId?: number;
  setDataCardId: (x: number) => void;
  clearStore: () => void;
  isLoading: boolean;
  setIsLoading: (x: boolean) => void;
  eolList: any;
  setEolList: (x: any) => void;
}

let store: StateCreator<EolStore, [], [], EolStore> | StoreApi<EolStore> = (set: SetState<EolStore>) => ({
  eolData: null,
  setEolData: (x) => {
    set(() => ({ eolData: x }));
  },
  dataCardId: undefined,
  setDataCardId: (dataCardId) => {
    set(() => ({ dataCardId }));
  },
  isLoading: false,
  setIsLoading: (x) => {
    set(() => ({ isLoading: x }));
  },
  eolList: [],
  setEolList: (x) => {
    set(() => ({ eolList: x }));
  },
  clearStore: () => {
    set(() => ({ eolData: null, dataCardId: undefined, isLoading: false, eolList: [] }));
  },
});

export const useEolStore = create(store);